module.exports = __webpack_public_path__ + "img/it-reference-04.3d4e3078.jpeg";